import { render, staticRenderFns } from "./MailTemplateDialog.vue?vue&type=template&id=bd50476e&scoped=true&"
import script from "./MailTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./MailTemplateDialog.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateDialog.vue?vue&type=style&index=0&id=bd50476e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50476e",
  null
  
)

export default component.exports